// extracted by mini-css-extract-plugin
export var footer = "_q1-5";
export var fulfillmentInput = "_q1-0";
export var shipDateInput = "_q1-1";
export var shipmentModal = "_q1-2";
export var shipmentModalContent = "_q1-3";
export var tableContainer = "_q1-4";